<!-- Breadcrumb padronizado -->
<app-breadcrumb containerStyle="normal"></app-breadcrumb>

<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Importações
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2 subtitle-text">
          Importe diretamente dados para o município e realize operações em lote. 
          Utilize os filtros abaixo para encontrar importações específicas.
        </p>
      </div>
    </div>

    <form #filterForm="ngForm" novalidate>
      <div class="form-row">
        <div class="col-md-8">
          <div class="form-group mb-3">
            <label class="form-label-custom">Período de Importação</label>
            <div class="d-flex align-items-center">
              <div class="input-group">
                <input
                  type="text"
                  id="data_inicio"
                  class="form-control"
                  mask="00/00/0000"
                  [(ngModel)]="filters.dataInicio"
                  name="data_inicio"
                  placeholder="dd/mm/yyyy"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
              <span class="mx-2 d-flex align-items-center" style="font-size: 14px;">até</span>
              <div class="input-group">
                <input
                  type="text"
                  id="data_fim"
                  class="form-control"
                  mask="00/00/0000"
                  [(ngModel)]="filters.dataFim"
                  name="data_fim"
                  placeholder="dd/mm/yyyy"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-4">
          <div class="form-group mb-3">
            <label class="form-label-custom">Limitar Itens Exibidos Em</label>
            <select class="form-control" [(ngModel)]="itemsPorPaginaGlobal" (change)="onItemsPorPaginaGlobalChange()" name="itemsPorPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
      </div>
    </form>
    
    <div class="form-row d-flex justify-content-end align-items-center mb-3">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="limparFiltros()"
        >
          Limpar filtros
        </button>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-primary mb-2 mb-md-0"
          (click)="aplicarFiltros()"
        >
          Pesquisar <i class="fa fa-search ml-1"></i>
        </button>
      </div>
    </div>

    <hr style="border-top: 1px solid #dee2e6; margin: 1.5rem 0;">

    <ngb-tabset type="tabs" class="custom-tabs" (tabChange)="onTabChange($event)">
      <!-- Tab Simplificado -->
      <ngb-tab title="Simplificado">
        <ng-template ngbTabContent>
          <div class="import-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 class="mb-1">Upload Simplificado</h5>
                <p class="mb-0 import-description">Importa dados de forma simplificada, utilizando um formato genérico.</p>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="openUploadSimplificadoModal(uploadSimplificadoModal)"
              >
                <i class="fa fa-upload mr-2"></i>Nova Importação
              </button>
            </div>

            <h6 class="mb-3 history-title">Histórico de Importação</h6>

            <table class="table text-center" style="padding: 10px" *ngIf="listaSimplificado && listaSimplificado.length > 0">
              <thead>
                <tr>
                  <th (click)="sortTable('data_inclusao', 'simplificado')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Data de Inclusão
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('data_inclusao', 'simplificado')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('data_inclusao', 'simplificado')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('data_inclusao', 'simplificado')"
                          class="fa"
                          [ngClass]="getSortIcon('data_inclusao', 'simplificado')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('status', 'simplificado')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Status
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('status', 'simplificado')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('status', 'simplificado')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('status', 'simplificado')"
                          class="fa"
                          [ngClass]="getSortIcon('status', 'simplificado')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('total_rows', 'simplificado')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Totais
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('total_rows', 'simplificado')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('total_rows', 'simplificado')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('total_rows', 'simplificado')"
                          class="fa"
                          [ngClass]="getSortIcon('total_rows', 'simplificado')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('inserted_rows', 'simplificado')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Inseridas
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('inserted_rows', 'simplificado')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('inserted_rows', 'simplificado')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('inserted_rows', 'simplificado')"
                          class="fa"
                          [ngClass]="getSortIcon('inserted_rows', 'simplificado')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center justify-content-center">
                      Arquivo
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let importacao of getPaginatedSimplificado()">
                  <td class="pl-3 pr-3 align-middle">
                    <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
                      {{ formatarData(importacao.data_inclusao) }}
                    </div>
                  </td>
                  <td class="text-center align-middle">
                    <span 
                      class="badge" 
                      [style.background-color]="getStatusColor(importacao.status)"
                      [style.color]="'white'"
                      style="font-size: 12px;">
                      {{ traduzirStatus(importacao.status) }}
                    </span>
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.total_rows }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.inserted_rows }}
                  </td>
                  <td class="d-flex justify-content-center">
                    <a [href]="importacao.url" target="_blank" class="btn btn-outline-primary btn-sm">
                      <i class="fa fa-download"></i> Download
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Mensagem quando não há dados -->
            <div *ngIf="!listaSimplificado || listaSimplificado.length === 0" class="no-data-message">
              <div class="no-data-content">
                <i class="fa fa-inbox fa-3x mb-3"></i>
                <h5>Nenhuma importação encontrada</h5>
                <p class="text-muted">Não há importações simplificadas registradas para este período.</p>
              </div>
            </div>

            <!-- Paginação simples -->
            <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px" *ngIf="listaSimplificado && listaSimplificado.length > 0">
              <ngb-pagination
                class="ml-auto"
                style="margin-top: 10px; margin-right: 10px"
                [(page)]="currentPageSimplificado"
                [pageSize]="itemsPorPaginaSimplificado"
                [collectionSize]="listaSimplificado.length"
                [maxSize]="3"
                [rotate]="true"
                [boundaryLinks]="true"
                size="sm">
              </ngb-pagination>
            </div>
          </div>
        </ng-template>
      </ngb-tab>

      <!-- Tab Servidores -->
      <ngb-tab title="Servidores">
        <ng-template ngbTabContent>
          <div class="import-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 class="mb-1">Upload Servidores</h5>
                <p class="mb-0 import-description">Importa os servidores e seus dados utilizando a base modelo da Secretaria da Previdência.</p>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="openUploadGeralModal(uploadGeralModal, 1)"
              >
                <i class="fa fa-upload mr-2"></i>Nova Importação
              </button>
            </div>

            <h6 class="mb-3 history-title">Histórico de Importação</h6>

            <table class="table text-center" style="padding: 10px" *ngIf="listaUploadServidores && listaUploadServidores.length > 0">
              <thead>
                <tr>
                  <th (click)="sortTable('data_inclusao', 'servidores')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Data de Inclusão
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('data_inclusao', 'servidores')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('data_inclusao', 'servidores')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('data_inclusao', 'servidores')"
                          class="fa"
                          [ngClass]="getSortIcon('data_inclusao', 'servidores')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('status', 'servidores')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Status
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('status', 'servidores')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('status', 'servidores')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('status', 'servidores')"
                          class="fa"
                          [ngClass]="getSortIcon('status', 'servidores')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('total_rows', 'servidores')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Totais
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('total_rows', 'servidores')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('total_rows', 'servidores')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('total_rows', 'servidores')"
                          class="fa"
                          [ngClass]="getSortIcon('total_rows', 'servidores')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('inserted_rows', 'servidores')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Inseridas
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('inserted_rows', 'servidores')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('inserted_rows', 'servidores')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('inserted_rows', 'servidores')"
                          class="fa"
                          [ngClass]="getSortIcon('inserted_rows', 'servidores')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center justify-content-center">
                      Arquivo
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let importacao of getPaginatedServidores()">
                  <td class="pl-3 pr-3 align-middle">
                    <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
                      {{ formatarData(importacao.data_inclusao) }}
                    </div>
                  </td>
                  <td class="text-center align-middle">
                    <span 
                      class="badge" 
                      [style.background-color]="getStatusColor(importacao.status)"
                      [style.color]="'white'"
                      style="font-size: 12px;">
                      {{ traduzirStatus(importacao.status) }}
                    </span>
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.total_rows }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.inserted_rows }}
                  </td>
                  <td class="d-flex justify-content-center">
                    <a [href]="importacao.url" target="_blank" class="btn btn-outline-primary btn-sm">
                      <i class="fa fa-download"></i> Download
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Mensagem quando não há dados -->
            <div *ngIf="!listaUploadServidores || listaUploadServidores.length === 0" class="no-data-message">
              <div class="no-data-content">
                <i class="fa fa-inbox fa-3x mb-3"></i>
                <h5>Nenhuma importação encontrada</h5>
                <p class="text-muted">Não há importações de servidores registradas para este período.</p>
              </div>
            </div>

            <!-- Paginação simples -->
            <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px" *ngIf="listaUploadServidores && listaUploadServidores.length > 0">
              <ngb-pagination
                class="ml-auto"
                style="margin-top: 10px; margin-right: 10px"
                [(page)]="currentPageServidores"
                [pageSize]="itemsPorPaginaServidores"
                [collectionSize]="listaUploadServidores.length"
                [maxSize]="3"
                [rotate]="true"
                [boundaryLinks]="true"
                size="sm">
              </ngb-pagination>
            </div>
          </div>
        </ng-template>
      </ngb-tab>

      <!-- Tab Aposentados -->
      <ngb-tab title="Aposentados">
        <ng-template ngbTabContent>
          <div class="import-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 class="mb-1">Upload Aposentados</h5>
                <p class="mb-0 import-description">Importa os aposentados e seus dados utilizando a base modelo da Secretaria da Previdência.</p>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="openUploadGeralModal(uploadGeralModal, 2)"
              >
                <i class="fa fa-upload mr-2"></i>Nova Importação
              </button>
            </div>

            <h6 class="mb-3 history-title">Histórico de Importação</h6>

            <table class="table text-center" style="padding: 10px" *ngIf="listaUploadAposentados && listaUploadAposentados.length > 0">
              <thead>
                <tr>
                  <th (click)="sortTable('data_inclusao', 'aposentados')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Data de Inclusão
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('data_inclusao', 'aposentados')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('data_inclusao', 'aposentados')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('data_inclusao', 'aposentados')"
                          class="fa"
                          [ngClass]="getSortIcon('data_inclusao', 'aposentados')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('status', 'aposentados')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Status
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('status', 'aposentados')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('status', 'aposentados')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('status', 'aposentados')"
                          class="fa"
                          [ngClass]="getSortIcon('status', 'aposentados')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('total_rows', 'aposentados')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Totais
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('total_rows', 'aposentados')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('total_rows', 'aposentados')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('total_rows', 'aposentados')"
                          class="fa"
                          [ngClass]="getSortIcon('total_rows', 'aposentados')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('inserted_rows', 'aposentados')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Inseridas
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('inserted_rows', 'aposentados')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('inserted_rows', 'aposentados')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('inserted_rows', 'aposentados')"
                          class="fa"
                          [ngClass]="getSortIcon('inserted_rows', 'aposentados')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center justify-content-center">
                      Arquivo
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let importacao of getPaginatedAposentados()">
                  <td class="pl-3 pr-3 align-middle">
                    <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
                      {{ formatarData(importacao.data_inclusao) }}
                    </div>
                  </td>
                  <td class="text-center align-middle">
                    <span 
                      class="badge" 
                      [style.background-color]="getStatusColor(importacao.status)"
                      [style.color]="'white'"
                      style="font-size: 12px;">
                      {{ traduzirStatus(importacao.status) }}
                    </span>
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.total_rows }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.inserted_rows }}
                  </td>
                  <td class="d-flex justify-content-center">
                    <a [href]="importacao.url" target="_blank" class="btn btn-outline-primary btn-sm">
                      <i class="fa fa-download"></i> Download
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Mensagem quando não há dados -->
            <div *ngIf="!listaUploadAposentados || listaUploadAposentados.length === 0" class="no-data-message">
              <div class="no-data-content">
                <i class="fa fa-inbox fa-3x mb-3"></i>
                <h5>Nenhuma importação encontrada</h5>
                <p class="text-muted">Não há importações de aposentados registradas para este período.</p>
              </div>
            </div>

            <!-- Paginação simples -->
            <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px" *ngIf="listaUploadAposentados && listaUploadAposentados.length > 0">
              <ngb-pagination
                class="ml-auto"
                style="margin-top: 10px; margin-right: 10px"
                [(page)]="currentPageAposentados"
                [pageSize]="itemsPorPaginaAposentados"
                [collectionSize]="listaUploadAposentados.length"
                [maxSize]="3"
                [rotate]="true"
                [boundaryLinks]="true"
                size="sm">
              </ngb-pagination>
            </div>
          </div>
        </ng-template>
      </ngb-tab>

      <!-- Tab Pensionistas -->
      <ngb-tab title="Pensionistas">
        <ng-template ngbTabContent>
          <div class="import-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 class="mb-1">Upload Pensionistas</h5>
                <p class="mb-0 import-description">Importa os pensionistas e seus dados utilizando a base modelo da Secretaria da Previdência.</p>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="openUploadGeralModal(uploadGeralModal, 3)"
              >
                <i class="fa fa-upload mr-2"></i>Nova Importação
              </button>
            </div>

            <h6 class="mb-3 history-title">Histórico de Importação</h6>

            <table class="table text-center" style="padding: 10px" *ngIf="listaUploadPensionistas && listaUploadPensionistas.length > 0">
              <thead>
                <tr>
                  <th (click)="sortTable('data_inclusao', 'pensionistas')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Data de Inclusão
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('data_inclusao', 'pensionistas')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('data_inclusao', 'pensionistas')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('data_inclusao', 'pensionistas')"
                          class="fa"
                          [ngClass]="getSortIcon('data_inclusao', 'pensionistas')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('status', 'pensionistas')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Status
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('status', 'pensionistas')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('status', 'pensionistas')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('status', 'pensionistas')"
                          class="fa"
                          [ngClass]="getSortIcon('status', 'pensionistas')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('total_rows', 'pensionistas')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Totais
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('total_rows', 'pensionistas')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('total_rows', 'pensionistas')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('total_rows', 'pensionistas')"
                          class="fa"
                          [ngClass]="getSortIcon('total_rows', 'pensionistas')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('inserted_rows', 'pensionistas')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Inseridas
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('inserted_rows', 'pensionistas')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('inserted_rows', 'pensionistas')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('inserted_rows', 'pensionistas')"
                          class="fa"
                          [ngClass]="getSortIcon('inserted_rows', 'pensionistas')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center justify-content-center">
                      Arquivo
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let importacao of getPaginatedPensionistas()">
                  <td class="pl-3 pr-3 align-middle">
                    <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
                      {{ formatarData(importacao.data_inclusao) }}
                    </div>
                  </td>
                  <td class="text-center align-middle">
                    <span 
                      class="badge" 
                      [style.background-color]="getStatusColor(importacao.status)"
                      [style.color]="'white'"
                      style="font-size: 12px;">
                      {{ traduzirStatus(importacao.status) }}
                    </span>
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.total_rows }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.inserted_rows }}
                  </td>
                  <td class="d-flex justify-content-center">
                    <a [href]="importacao.url" target="_blank" class="btn btn-outline-primary btn-sm">
                      <i class="fa fa-download"></i> Download
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Mensagem quando não há dados -->
            <div *ngIf="!listaUploadPensionistas || listaUploadPensionistas.length === 0" class="no-data-message">
              <div class="no-data-content">
                <i class="fa fa-inbox fa-3x mb-3"></i>
                <h5>Nenhuma importação encontrada</h5>
                <p class="text-muted">Não há importações de pensionistas registradas para este período.</p>
              </div>
            </div>

            <!-- Paginação simples -->
            <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px" *ngIf="listaUploadPensionistas && listaUploadPensionistas.length > 0">
              <ngb-pagination
                class="ml-auto"
                style="margin-top: 10px; margin-right: 10px"
                [(page)]="currentPagePensionistas"
                [pageSize]="itemsPorPaginaPensionistas"
                [collectionSize]="listaUploadPensionistas.length"
                [maxSize]="3"
                [rotate]="true"
                [boundaryLinks]="true"
                size="sm">
              </ngb-pagination>
            </div>
          </div>
        </ng-template>
      </ngb-tab>

      <!-- Tab Idade Aposentadoria -->
      <ngb-tab title="Idade Aposentadoria">
        <ng-template ngbTabContent>
          <div class="import-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 class="mb-1">Upload Idade Aposentadoria</h5>
                <p class="mb-0 import-description">Importa a idade de aposentadoria projetada dos servidores ativos.</p>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="openUploadIdadeAposentadoriaModal(uploadIdadeAposentadoriaModal)"
              >
                <i class="fa fa-upload mr-2"></i>Nova Importação
              </button>
            </div>

            <h6 class="mb-3 history-title">Histórico de Importação</h6>

            <table class="table text-center" style="padding: 10px" *ngIf="listaUploadIdadeAposentadoria && listaUploadIdadeAposentadoria.length > 0">
              <thead>
                <tr>
                  <th (click)="sortTable('data_inclusao', 'idadeAposentadoria')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Data de Inclusão
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('data_inclusao', 'idadeAposentadoria')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('data_inclusao', 'idadeAposentadoria')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('data_inclusao', 'idadeAposentadoria')"
                          class="fa"
                          [ngClass]="getSortIcon('data_inclusao', 'idadeAposentadoria')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('status', 'idadeAposentadoria')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Status
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('status', 'idadeAposentadoria')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('status', 'idadeAposentadoria')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('status', 'idadeAposentadoria')"
                          class="fa"
                          [ngClass]="getSortIcon('status', 'idadeAposentadoria')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('total_rows', 'idadeAposentadoria')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Totais
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('total_rows', 'idadeAposentadoria')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('total_rows', 'idadeAposentadoria')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('total_rows', 'idadeAposentadoria')"
                          class="fa"
                          [ngClass]="getSortIcon('total_rows', 'idadeAposentadoria')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('inserted_rows', 'idadeAposentadoria')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Inseridas
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('inserted_rows', 'idadeAposentadoria')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('inserted_rows', 'idadeAposentadoria')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('inserted_rows', 'idadeAposentadoria')"
                          class="fa"
                          [ngClass]="getSortIcon('inserted_rows', 'idadeAposentadoria')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th>Arquivo</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let importacao of getPaginatedIdadeAposentadoria()">
                  <td class="pl-3 pr-3 align-middle">
                    <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
                      {{ formatarData(importacao.data_inclusao) }}
                    </div>
                  </td>
                  <td class="text-center align-middle">
                    <span 
                      class="badge" 
                      [style.background-color]="getStatusColor(importacao.status)"
                      [style.color]="'white'"
                      style="font-size: 12px;">
                      {{ traduzirStatus(importacao.status) }}
                    </span>
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.total_rows }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.inserted_rows }}
                  </td>
                  <td class="text-center align-middle">
                    <a [href]="importacao.url" target="_blank" class="btn btn-outline-primary btn-sm">
                      <i class="fa fa-download"></i> Download
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Mensagem quando não há dados -->
            <div *ngIf="!listaUploadIdadeAposentadoria || listaUploadIdadeAposentadoria.length === 0" class="no-data-message">
              <div class="no-data-content">
                <i class="fa fa-inbox fa-3x mb-3"></i>
                <h5>Nenhuma importação encontrada</h5>
                <p class="text-muted">Não há importações de idade de aposentadoria registradas para este período.</p>
              </div>
            </div>

            <!-- Paginação simples -->
            <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px" *ngIf="listaUploadIdadeAposentadoria && listaUploadIdadeAposentadoria.length > 0">
              <ngb-pagination
                class="ml-auto"
                style="margin-top: 10px; margin-right: 10px"
                [(page)]="currentPageIdadeAposentadoria"
                [pageSize]="itemsPorPaginaIdadeAposentadoria"
                [collectionSize]="listaUploadIdadeAposentadoria.length"
                [maxSize]="3"
                [rotate]="true"
                [boundaryLinks]="true"
                size="sm">
              </ngb-pagination>
            </div>
          </div>
        </ng-template>
      </ngb-tab>

      <!-- Tab Servidores Censo -->
      <ngb-tab title="Servidores Censo">
        <ng-template ngbTabContent>
          <div class="import-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 class="mb-1">Upload Servidores Censo</h5>
                <p class="mb-0 import-description">Importa os servidores para o censo utilizando formato específico.</p>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="openUploadServidoresCensoModal(uploadServidoresCensoModal)"
              >
                <i class="fa fa-upload mr-2"></i>Nova Importação
              </button>
            </div>

            <h6 class="mb-3 history-title">Histórico de Importação</h6>

            <table class="table text-center" style="padding: 10px" *ngIf="listaUploadServidoresCenso && listaUploadServidoresCenso.length > 0">
              <thead>
                <tr>
                  <th (click)="sortTable('data_inclusao', 'servidoresCenso')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Data de Inclusão
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('data_inclusao', 'servidoresCenso')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('data_inclusao', 'servidoresCenso')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('data_inclusao', 'servidoresCenso')"
                          class="fa"
                          [ngClass]="getSortIcon('data_inclusao', 'servidoresCenso')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('status', 'servidoresCenso')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Status
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('status', 'servidoresCenso')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('status', 'servidoresCenso')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('status', 'servidoresCenso')"
                          class="fa"
                          [ngClass]="getSortIcon('status', 'servidoresCenso')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('total_rows', 'servidoresCenso')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Totais
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('total_rows', 'servidoresCenso')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('total_rows', 'servidoresCenso')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('total_rows', 'servidoresCenso')"
                          class="fa"
                          [ngClass]="getSortIcon('total_rows', 'servidoresCenso')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('inserted_rows', 'servidoresCenso')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Inseridas
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('inserted_rows', 'servidoresCenso')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('inserted_rows', 'servidoresCenso')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('inserted_rows', 'servidoresCenso')"
                          class="fa"
                          [ngClass]="getSortIcon('inserted_rows', 'servidoresCenso')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center justify-content-center">
                      Progresso
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center justify-content-center">
                      Arquivo
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center justify-content-center">
                      Não importados
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let importacao of getPaginatedServidoresCenso()">
                  <td class="pl-3 pr-3 align-middle">
                    <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
                      {{ formatarData(importacao.data_inclusao) }}
                    </div>
                  </td>
                  <td class="text-center align-middle">
                    <span 
                      class="badge" 
                      [style.background-color]="getStatusColor(importacao.status)"
                      [style.color]="'white'"
                      style="font-size: 12px;">
                      {{ traduzirStatus(importacao.status) }}
                    </span>
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.total_rows }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.inserted_rows }}
                  </td>
                  <td class="text-center align-middle">
                    <div class="progress-container-table">
                      <div class="progress" style="height: 20px; width: 100px; margin: 0 auto;">
                        <div 
                          class="progress-bar" 
                          [ngClass]="{
                            'progress-bar-striped progress-bar-animated': importacao.status === 1,
                            'bg-success': importacao.status === 2,
                            'bg-warning': importacao.status === 1,
                            'bg-secondary': importacao.status === 0,
                            'bg-danger': importacao.status === 3
                          }"
                          role="progressbar" 
                          [style.width.%]="getProgressPercentage(importacao)"
                          [attr.aria-valuenow]="getProgressPercentage(importacao)" 
                          aria-valuemin="0" 
                          aria-valuemax="100">
                          <span class="progress-text">{{ getProgressPercentage(importacao) }}%</span>
                        </div>
                      </div>
                      <small class="progress-details">
                        {{ importacao.inserted_rows || 0 }} / {{ importacao.total_rows }}
                      </small>
                    </div>
                  </td>
                  <td class="d-flex justify-content-center">
                    <a [href]="importacao.url" target="_blank" class="btn btn-outline-primary btn-sm">
                      <i class="fa fa-download"></i> Download
                    </a>
                  </td>
                  <td class="text-center align-middle">
                    <button
                      type="button"
                      class="btn btn-outline-danger btn-sm"
                      *ngIf="getItensNaoImportados(importacao.invalid_cpfs).length > 0"
                      (click)="abrirNaoImportados(importacao)"
                    >
                      <i class="fa fa-exclamation-circle mr-1"></i>
                      Ver ({{ getItensNaoImportados(importacao.invalid_cpfs).length }})
                    </button>
                    <span
                      *ngIf="getItensNaoImportados(importacao.invalid_cpfs).length === 0"
                      class="text-muted"
                    >
                      —
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Mensagem quando não há dados -->
            <div *ngIf="!listaUploadServidoresCenso || listaUploadServidoresCenso.length === 0" class="no-data-message">
              <div class="no-data-content">
                <i class="fa fa-inbox fa-3x mb-3"></i>
                <h5>Nenhuma importação encontrada</h5>
                <p class="text-muted">Não há importações de servidores censo registradas para este período.</p>
              </div>
            </div>

            <!-- Paginação simples -->
            <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px" *ngIf="listaUploadServidoresCenso && listaUploadServidoresCenso.length > 0">
              <ngb-pagination
                class="ml-auto"
                style="margin-top: 10px; margin-right: 10px"
                [(page)]="currentPageServidoresCenso"
                [pageSize]="itemsPorPaginaServidoresCenso"
                [collectionSize]="listaUploadServidoresCenso.length"
                [maxSize]="3"
                [rotate]="true"
                [boundaryLinks]="true"
                size="sm">
              </ngb-pagination>
            </div>
          </div>
        </ng-template>
      </ngb-tab>

      <!-- Tab Importação Mensal -->
      <ngb-tab title="Salário Mensal">
        <ng-template ngbTabContent>
          <div class="import-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 class="mb-1">Importação Mensal</h5>
                <p class="mb-0 import-description">Importa os salários mensais de contribuição dos servidores.</p>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="openUploadMovimentacaoModal(uploadMovimentacaoModal)"
              >
                <i class="fa fa-upload mr-2"></i>Nova Importação
              </button>
            </div>

            <h6 class="mb-3 history-title">Histórico de Importação</h6>

            <table class="table text-center" style="padding: 10px" *ngIf="listaImportacaoMensal && listaImportacaoMensal.length > 0">
              <thead>
                <tr>
                  <th (click)="sortTable('data_inclusao', 'mensal')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Data de Inclusão
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('data_inclusao', 'mensal')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('data_inclusao', 'mensal')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('data_inclusao', 'mensal')"
                          class="fa"
                          [ngClass]="getSortIcon('data_inclusao', 'mensal')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('status', 'mensal')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Status
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('status', 'mensal')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('status', 'mensal')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('status', 'mensal')"
                          class="fa"
                          [ngClass]="getSortIcon('status', 'mensal')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('total_rows', 'mensal')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Totais
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('total_rows', 'mensal')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('total_rows', 'mensal')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('total_rows', 'mensal')"
                          class="fa"
                          [ngClass]="getSortIcon('total_rows', 'mensal')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('inserted_rows', 'mensal')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Inseridas
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('inserted_rows', 'mensal')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('inserted_rows', 'mensal')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('inserted_rows', 'mensal')"
                          class="fa"
                          [ngClass]="getSortIcon('inserted_rows', 'mensal')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('competencia', 'mensal')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Competência
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('competencia', 'mensal')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('competencia', 'mensal')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('competencia', 'mensal')"
                          class="fa"
                          [ngClass]="getSortIcon('competencia', 'mensal')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th>Arquivo</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let importacao of getPaginatedMensal()">
                  <td class="pl-3 pr-3 align-middle">
                    <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
                      {{ formatarData(importacao.data_inclusao) }}
                    </div>
                  </td>
                  <td class="text-center align-middle">
                    <span 
                      class="badge" 
                      [style.background-color]="getStatusColor(importacao.status)"
                      [style.color]="'white'"
                      style="font-size: 12px;">
                      {{ traduzirStatus(importacao.status) }}
                    </span>
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.total_rows }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.inserted_rows }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ formatarCompetencia(importacao.competencia) }}
                  </td>
                  <td class="text-center align-middle">
                    <a [href]="importacao.url" target="_blank" class="btn btn-outline-primary btn-sm">
                      <i class="fa fa-download"></i> Download
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Mensagem quando não há dados -->
            <div *ngIf="!listaImportacaoMensal || listaImportacaoMensal.length === 0" class="no-data-message">
              <div class="no-data-content">
                <i class="fa fa-inbox fa-3x mb-3"></i>
                <h5>Nenhuma importação encontrada</h5>
                <p class="text-muted">Não há importações de salário mensal registradas para este período.</p>
              </div>
            </div>

            <!-- Paginação simples -->
            <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px" *ngIf="listaImportacaoMensal && listaImportacaoMensal.length > 0">
              <ngb-pagination
                class="ml-auto"
                style="margin-top: 10px; margin-right: 10px"
                [(page)]="currentPageMensal"
                [pageSize]="itemsPorPaginaMensal"
                [collectionSize]="listaImportacaoMensal.length"
                [maxSize]="3"
                [rotate]="true"
                [boundaryLinks]="true"
                size="sm">
              </ngb-pagination>
            </div>
          </div>
        </ng-template>
      </ngb-tab>

      <!-- Tab Salário Base -->
      <ngb-tab title="Salário Base">
        <ng-template ngbTabContent>
          <div class="import-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 class="mb-1">Importação Salário Base</h5>
                <p class="mb-0 import-description">Importa os salários base dos servidores (ativos, aposentados e pensionistas).</p>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="openUploadSalarioBaseModal(uploadSalarioBaseModal)"
              >
                <i class="fa fa-upload mr-2"></i>Nova Importação
              </button>
            </div>

            <h6 class="mb-3 history-title">Histórico de Importação</h6>

            <table class="table text-center" style="padding: 10px" *ngIf="listaSalarioBase && listaSalarioBase.length > 0">
              <thead>
                <tr>
                  <th (click)="sortTable('data_inclusao', 'salarioBase')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Data de Inclusão
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('data_inclusao', 'salarioBase')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('data_inclusao', 'salarioBase')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('data_inclusao', 'salarioBase')"
                          class="fa"
                          [ngClass]="getSortIcon('data_inclusao', 'salarioBase')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('status', 'salarioBase')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Status
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('status', 'salarioBase')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('status', 'salarioBase')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('status', 'salarioBase')"
                          class="fa"
                          [ngClass]="getSortIcon('status', 'salarioBase')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('total_rows', 'salarioBase')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Linhas Totais
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('total_rows', 'salarioBase')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('total_rows', 'salarioBase')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('total_rows', 'salarioBase')"
                          class="fa"
                          [ngClass]="getSortIcon('total_rows', 'salarioBase')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('inserted_rows', 'salarioBase')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Atualizados
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('inserted_rows', 'salarioBase')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('inserted_rows', 'salarioBase')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('inserted_rows', 'salarioBase')"
                          class="fa"
                          [ngClass]="getSortIcon('inserted_rows', 'salarioBase')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center justify-content-center">
                      Arquivo
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center justify-content-center">
                      Log
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let importacao of getPaginatedSalarioBase()">
                  <td class="pl-3 pr-3 align-middle">
                    <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
                      {{ formatarData(importacao.data_inclusao) }}
                    </div>
                  </td>
                  <td class="text-center align-middle">
                    <span 
                      class="badge" 
                      [style.background-color]="getStatusColorSalarioBase(importacao.status)"
                      [style.color]="'white'"
                      style="font-size: 12px;">
                      {{ traduzirStatusSalarioBase(importacao.status) }}
                    </span>
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.total_rows || 0 }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.inserted_rows || 0 }}
                  </td>
                  <td class="text-center align-middle">
                    <a [href]="importacao.url" target="_blank" class="btn btn-outline-primary btn-sm">
                      <i class="fa fa-download"></i> Download
                    </a>
                  </td>
                  <td class="text-center align-middle">
                    <button 
                      *ngIf="podeVisualizarLog(importacao)"
                      type="button"
                      class="btn btn-outline-info btn-sm"
                      (click)="abrirLogSalarioBase(importacao, logSalarioBaseModal)"
                      title="Visualizar log de processamento">
                      <i class="fa fa-file-text-o"></i> Ver Log
                    </button>
                    <span 
                      *ngIf="importacao.status === 0"
                      class="text-muted"
                      style="font-size: 12px;">
                      Aguardando
                    </span>
                    <span 
                      *ngIf="importacao.status === 1"
                      class="text-warning"
                      style="font-size: 12px;">
                      <i class="fa fa-spinner fa-spin"></i> Processando
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Mensagem quando não há dados -->
            <div *ngIf="!listaSalarioBase || listaSalarioBase.length === 0" class="no-data-message">
              <div class="no-data-content">
                <i class="fa fa-inbox fa-3x mb-3"></i>
                <h5>Nenhuma importação encontrada</h5>
                <p class="text-muted">Não há importações de salário base registradas para este período.</p>
              </div>
            </div>

            <!-- Paginação simples -->
            <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px" *ngIf="listaSalarioBase && listaSalarioBase.length > 0">
              <ngb-pagination
                class="ml-auto"
                style="margin-top: 10px; margin-right: 10px"
                [(page)]="currentPageSalarioBase"
                [pageSize]="itemsPorPaginaSalarioBase"
                [collectionSize]="listaSalarioBase.length"
                [maxSize]="3"
                [rotate]="true"
                [boundaryLinks]="true"
                size="sm">
              </ngb-pagination>
            </div>
          </div>
        </ng-template>
      </ngb-tab>

      <!-- Tab FlaxFlow -->
      <ngb-tab title="FlaxFlow">
        <ng-template ngbTabContent>
          <div class="import-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 class="mb-1">Upload IA FlaxFlow</h5>
                <p class="mb-0 import-description">Cadastra um servidor através da integração FlaxFlow pelo arquivo de Ficha de Cadastro.</p>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="openModalFlaxFlow(uploadFlaxFlowModal)"
              >
                <i class="fa fa-upload mr-2"></i>Nova Importação
              </button>
            </div>

            <!-- Filtros de pesquisa FlaxFlow -->
            <div class="card mb-3" style="background-color: #f8f9fa; border-radius: 8px;">
              <div class="card-body">
                <h6 class="mb-3" style="color: #4e7977; font-weight: 600;">Filtros de Pesquisa</h6>
                <form #filtrosFlaxFlowForm="ngForm" novalidate>
                  <div class="form-row align-items-end">
                    <div class="col-md-4">
                      <div class="form-group mb-3">
                        <label class="form-label-custom">Nome do Servidor</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="filtrosFlaxFlow.nomeServidor"
                          name="nomeServidor"
                          placeholder="Digite o nome do servidor"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group mb-3">
                        <label class="form-label-custom">CPF</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="filtrosFlaxFlow.cpf"
                          name="cpf"
                          placeholder="Digite o CPF (com ou sem formatação)"
                          mask="000.000.000-00"
                        />
                      </div>
                    </div>
                    <div class="col-md-4 d-flex justify-content-end align-items-end mb-3">
                      <div class="col-auto mr-2">
                        <button
                          type="button"
                          class="btn btn-outline-primary"
                          (click)="limparFiltrosFlaxFlow()"
                        >
                          Limpar filtros
                        </button>
                      </div>
                      <div class="col-auto">
                        <button
                          type="button"
                          class="btn btn-primary"
                          (click)="aplicarFiltrosFlaxFlow()"
                        >
                          Pesquisar <i class="fa fa-search ml-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <h6 class="mb-3 history-title">Histórico de Importação</h6>

            <table class="table text-center" style="padding: 10px" *ngIf="listaFlaxFlow && listaFlaxFlow.length > 0">
              <thead>
                <tr>
                  <th (click)="sortTable('statusflaxflow', 'flaxFlow')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Status
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('statusflaxflow', 'flaxFlow')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('statusflaxflow', 'flaxFlow')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('statusflaxflow', 'flaxFlow')"
                          class="fa"
                          [ngClass]="getSortIcon('statusflaxflow', 'flaxFlow')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('data_envio', 'flaxFlow')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Data de Envio
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('data_envio', 'flaxFlow')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('data_envio', 'flaxFlow')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('data_envio', 'flaxFlow')"
                          class="fa"
                          [ngClass]="getSortIcon('data_envio', 'flaxFlow')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('data_retorno', 'flaxFlow')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Data de Retorno
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('data_retorno', 'flaxFlow')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('data_retorno', 'flaxFlow')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('data_retorno', 'flaxFlow')"
                          class="fa"
                          [ngClass]="getSortIcon('data_retorno', 'flaxFlow')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('tamanho', 'flaxFlow')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Tamanho (MB)
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('tamanho', 'flaxFlow')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('tamanho', 'flaxFlow')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('tamanho', 'flaxFlow')"
                          class="fa"
                          [ngClass]="getSortIcon('tamanho', 'flaxFlow')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('nome_servidor', 'flaxFlow')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Nome do Servidor
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('nome_servidor', 'flaxFlow')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('nome_servidor', 'flaxFlow')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('nome_servidor', 'flaxFlow')"
                          class="fa"
                          [ngClass]="getSortIcon('nome_servidor', 'flaxFlow')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('cpf_servidor', 'flaxFlow')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      CPF
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('cpf_servidor', 'flaxFlow')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('cpf_servidor', 'flaxFlow')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('cpf_servidor', 'flaxFlow')"
                          class="fa"
                          [ngClass]="getSortIcon('cpf_servidor', 'flaxFlow')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th (click)="sortTable('action', 'flaxFlow')" class="cursor-pointer">
                    <div class="d-flex align-items-center justify-content-center">
                      Tipo de Ação
                      <div class="sort-icons ml-1">
                        <i *ngIf="!isColumnSorted('action', 'flaxFlow')" class="fa fa-caret-up"></i>
                        <i *ngIf="!isColumnSorted('action', 'flaxFlow')" class="fa fa-caret-down"></i>
                        <i
                          *ngIf="isColumnSorted('action', 'flaxFlow')"
                          class="fa"
                          [ngClass]="getSortIcon('action', 'flaxFlow')"
                        ></i>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center justify-content-center">
                      Arquivo Original
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center justify-content-center">
                      JSON
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let importacao of getPaginatedFlaxFlow()">
                  <td class="text-center align-middle">
                    <span 
                      class="badge" 
                      [style.background-color]="getFlaxFlowStatusBackgroundColor(importacao.statusflaxflow)"
                      [style.color]="getFlaxFlowStatusColor(importacao.statusflaxflow)"
                      style="font-size: 12px;">
                      {{ traduzirStatusFlaxFlow(importacao.statusflaxflow) }}
                    </span>
                  </td>
                  <td class="pl-3 pr-3 align-middle">
                    <div class="d-flex flex-column align-items-center justify-content-center texto-linha-tabela">
                      <div>{{ formatarDataCurta(importacao.data_envio) }}</div>
                      <div>{{ formatarHora(importacao.data_envio) }}</div>
                    </div>
                  </td>
                  <td class="pl-3 pr-3 align-middle">
                    <div class="d-flex flex-column align-items-center justify-content-center texto-linha-tabela">
                      <div>{{ formatarDataCurta(importacao.data_retorno) }}</div>
                      <div>{{ formatarHora(importacao.data_retorno) }}</div>
                    </div>
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ formatarTamanho(importacao.tamanho) }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.nome_servidor || '-' }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ importacao.cpf_servidor || '-' }}
                  </td>
                  <td class="text-center align-middle texto-linha-tabela">
                    {{ traduzirActionFlaxFlow(importacao.action) }}
                  </td>
                  <td class="text-center align-middle">
                    <a 
                      *ngIf="importacao.chave"
                      [href]="importacao.chave" 
                      target="_blank" 
                      class="text-primary"
                      style="text-decoration: none; cursor: pointer;">
                      Download
                    </a>
                    <span 
                      *ngIf="!importacao.chave"
                      class="text-muted"
                      style="opacity: 0.5;">
                      Download
                    </span>
                  </td>
                  <td class="text-center align-middle">
                    <button 
                      *ngIf="(importacao.statusflaxflow === 'PROCESSAMENTO_COMPLETO' || importacao.statusflaxflow === 'PROCESSADO' || importacao.statusflaxflow === 'DESATIVADO' || importacao.statusflaxflow === 'ANEXADO' || importacao.statusflaxflow === 'TEMPO_LIMITE_EXCEDIDO' || importacao.statusflaxflow === 'TEMPO LIMITE EXCEDIDO') && importacao.resultado_flaxflow_json && isJsonValid(importacao.resultado_flaxflow_json)"
                      type="button"
                      class="btn btn-outline-primary btn-sm"
                      (click)="handleJsonClick(importacao)"
                      [title]="getJsonButtonTitle(importacao)">
                      <i class="fa" [ngClass]="getJsonButtonIcon(importacao)"></i>
                    </button>
                    <span 
                      *ngIf="importacao.statusflaxflow === 'EM_PROCESSAMENTO' || importacao.statusflaxflow === 'PROCESSANDO'"
                      class="text-muted"
                      style="opacity: 0.5;">
                      <i class="fa fa-eye"></i>
                    </span>
                    <span 
                      *ngIf="(importacao.statusflaxflow === 'PROCESSAMENTO_COMPLETO' || importacao.statusflaxflow === 'PROCESSADO' || importacao.statusflaxflow === 'DESATIVADO' || importacao.statusflaxflow === 'ANEXADO' || importacao.statusflaxflow === 'TEMPO_LIMITE_EXCEDIDO' || importacao.statusflaxflow === 'TEMPO LIMITE EXCEDIDO') && importacao.resultado_flaxflow_json && isLink(importacao.resultado_flaxflow_json)"
                      class="text-muted"
                      style="opacity: 0.5;"
                      title="Este arquivo não é um JSON">
                      <i class="fa fa-ban"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Mensagem quando não há dados -->
            <div *ngIf="!listaFlaxFlow || listaFlaxFlow.length === 0" class="no-data-message">
              <div class="no-data-content">
                <i class="fa fa-inbox fa-3x mb-3"></i>
                <h5>Nenhuma importação encontrada</h5>
                <p class="text-muted">Não há importações FlaxFlow registradas para este período.</p>
              </div>
            </div>

            <!-- Paginação simples -->
            <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px" *ngIf="listaFlaxFlow && listaFlaxFlow.length > 0">
              <ngb-pagination
                class="ml-auto"
                style="margin-top: 10px; margin-right: 10px"
                [(page)]="currentPageFlaxFlow"
                [pageSize]="itemsPorPaginaFlaxFlow"
                [collectionSize]="flaxFlowPagination.total"
                [maxSize]="3"
                [rotate]="true"
                [boundaryLinks]="true"
                size="sm"
                [disabled]="flaxFlowLoading"
                (pageChange)="onFlaxFlowPageChange($event)">
              </ngb-pagination>
            </div>
          </div>
        </ng-template>
      </ngb-tab>
    </ngb-tabset>
  </div>
</div>

<ngx-spinner></ngx-spinner>

<!-- Modais de Upload -->

<!-- Modal para Upload Simplificado -->
<ng-template #uploadSimplificadoModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">Upload Simplificado</h4>
    <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <!-- Linha divisória após título principal -->
  <hr class="modal-divider">
  
  <div class="modal-body">
    <h6 class="section-title">Informações do Arquivo</h6>
    <p class="modal-description mb-4">Selecione um arquivo CSV para importação simplificada de servidores.</p>
    
    <form #uploadForm="ngForm" novalidate>
      <div class="form-group mb-4">
        <label for="fileInput" class="form-label">ARQUIVO CSV</label>
        <input 
          type="file" 
          id="fileInput" 
          class="form-control" 
          accept=".csv"
          (change)="onFileSelected($event)"
          [class.is-invalid]="uploadData.errors.file"
          required>
        <div class="invalid-feedback" *ngIf="uploadData.errors.file">
          {{ uploadData.errors.file }}
        </div>
        <small class="form-text text-muted">Apenas arquivos no formato .csv são aceitos.</small>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <!-- HR no rodapé ao invés de linha inteira -->
    <hr class="footer-divider">
    <div class="d-flex">
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')" [disabled]="uploadData.loading">
        Voltar
      </button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="processarUploadSimplificado(modal)"
        [disabled]="!uploadData.file || uploadData.loading">
        <span *ngIf="uploadData.loading" class="spinner-border spinner-border-sm me-2"></span>
        {{ uploadData.loading ? 'Processando...' : 'Enviar' }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #naoImportadosModal let-modal>
  <div class="modal-header">
    <div>
      <h4 class="modal-title">Registros não importados</h4>
      <p class="mb-0 text-muted">
        Importação de {{ formatarData(importacaoSelecionada?.data_inclusao) }}
        — {{ itensNaoImportados.length }} registro(s)
      </p>
    </div>
    <button
      type="button"
      class="close"
      aria-label="Fechar"
      (click)="modal.dismiss('Close')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-sm table-hover mb-0">
        <thead>
          <tr>
            <th style="width: 70px;">#</th>
            <th>Registro / motivo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itensNaoImportados; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="downloadInvalidCpfs(itensNaoImportados)"
    >
      <i class="fa fa-download mr-1"></i>Baixar CSV
    </button>
    <button type="button" class="btn btn-primary" (click)="modal.close('Close')">
      Fechar
    </button>
  </div>
</ng-template>

<!-- Modal para Upload Idade Aposentadoria -->
<ng-template #uploadIdadeAposentadoriaModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">Upload Idade Aposentadoria</h4>
    <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <!-- Linha divisória após título principal -->
  <hr class="modal-divider">
  
  <div class="modal-body">
    <h6 class="section-title">Informações do Arquivo</h6>
    <p class="modal-description mb-4">Selecione um arquivo CSV com dados de idade de aposentadoria dos servidores.</p>
    
    <form #uploadIdadeForm="ngForm" novalidate>
      <div class="form-group mb-4">
        <label for="fileInputIdade" class="form-label">ARQUIVO CSV</label>
        <input 
          type="file" 
          id="fileInputIdade" 
          class="form-control" 
          accept=".csv"
          (change)="onFileSelected($event)"
          [class.is-invalid]="uploadData.errors.file"
          required>
        <div class="invalid-feedback" *ngIf="uploadData.errors.file">
          {{ uploadData.errors.file }}
        </div>
        <small class="form-text text-muted">Apenas arquivos no formato .csv são aceitos.</small>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <!-- HR no rodapé ao invés de linha inteira -->
    <hr class="footer-divider">
    <div class="d-flex">
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')" [disabled]="uploadData.loading">
        Voltar
      </button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="processarUploadIdadeAposentadoria(modal)"
        [disabled]="!uploadData.file || uploadData.loading">
        <span *ngIf="uploadData.loading" class="spinner-border spinner-border-sm me-2"></span>
        {{ uploadData.loading ? 'Processando...' : 'Enviar' }}
      </button>
    </div>
  </div>
</ng-template>

<!-- Modal para Upload Geral (Servidores, Aposentados, Pensionistas) -->
<ng-template #uploadGeralModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">{{ getUploadTitle() }}</h4>
    <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <!-- Linha divisória após título principal -->
  <hr class="modal-divider">
  
  <div class="modal-body">
    <h6 class="section-title">Informações do Arquivo</h6>
    <p class="modal-description mb-4">{{ getUploadDescription() }}</p>
    
    <form #uploadGeralForm="ngForm" novalidate>
      <div class="form-group mb-4">
        <label for="fileInputGeral" class="form-label">ARQUIVO CSV</label>
        <input 
          type="file" 
          id="fileInputGeral" 
          class="form-control" 
          accept=".csv"
          (change)="onFileSelected($event)"
          [class.is-invalid]="uploadData.errors.file"
          required>
        <div class="invalid-feedback" *ngIf="uploadData.errors.file">
          {{ uploadData.errors.file }}
        </div>
        <small class="form-text text-muted">Apenas arquivos no formato .csv são aceitos.</small>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <!-- HR no rodapé ao invés de linha inteira -->
    <hr class="footer-divider">
    <div class="d-flex">
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')" [disabled]="uploadData.loading">
        Voltar
      </button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="processarUploadGeral(modal)"
        [disabled]="!uploadData.file || uploadData.loading">
        <span *ngIf="uploadData.loading" class="spinner-border spinner-border-sm me-2"></span>
        {{ uploadData.loading ? 'Processando...' : 'Enviar' }}
      </button>
    </div>
  </div>
</ng-template>

<!-- Modal para Upload Movimentação Mensal -->
<ng-template #uploadMovimentacaoModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">Importação Movimentações Mensais</h4>
    <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <!-- Linha divisória após título principal -->
  <hr class="modal-divider">
  
  <div class="modal-body">
    <h6 class="section-title">Informações da Importação</h6>
    <p class="modal-description mb-4">Selecione o mês, ano e arquivo Excel para importação dos salários mensais.</p>
    
    <form #uploadMovimentacaoForm="ngForm" novalidate>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="monthSelect" class="form-label">MÊS</label>
            <select 
              id="monthSelect" 
              class="form-control" 
              [(ngModel)]="uploadData.month"
              name="month"
              [class.is-invalid]="uploadData.errors.month"
              required>
              <option value="" disabled>Selecione o mês</option>
              <option value="01">Janeiro</option>
              <option value="02">Fevereiro</option>
              <option value="03">Março</option>
              <option value="04">Abril</option>
              <option value="05">Maio</option>
              <option value="06">Junho</option>
              <option value="07">Julho</option>
              <option value="08">Agosto</option>
              <option value="09">Setembro</option>
              <option value="10">Outubro</option>
              <option value="11">Novembro</option>
              <option value="12">Dezembro</option>
            </select>
            <div class="invalid-feedback" *ngIf="uploadData.errors.month">
              {{ uploadData.errors.month }}
            </div>
          </div>
        </div>
        
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label for="yearInput" class="form-label">ANO</label>
            <input 
              type="number" 
              id="yearInput" 
              class="form-control" 
              [(ngModel)]="uploadData.year"
              name="year"
              placeholder="Digite o ano"
              [class.is-invalid]="uploadData.errors.year"
              min="2020"
              max="2030"
              required>
            <div class="invalid-feedback" *ngIf="uploadData.errors.year">
              {{ uploadData.errors.year }}
            </div>
          </div>
        </div>
      </div>
      
      <div class="form-group mb-4">
        <label for="fileInputMovimentacao" class="form-label">ARQUIVO EXCEL</label>
        <input 
          type="file" 
          id="fileInputMovimentacao" 
          class="form-control" 
          accept=".xls,.xlsx"
          (change)="onFileSelected($event)"
          [class.is-invalid]="uploadData.errors.file"
          required>
        <div class="invalid-feedback" *ngIf="uploadData.errors.file">
          {{ uploadData.errors.file }}
        </div>
        <small class="form-text text-muted">Apenas arquivos no formato .xls ou .xlsx são aceitos.</small>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <!-- HR no rodapé ao invés de linha inteira -->
    <hr class="footer-divider">
    <div class="d-flex">
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')" [disabled]="uploadData.loading">
        Voltar
      </button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="processarUploadMovimentacao(modal)"
        [disabled]="!uploadData.file || !uploadData.month || !uploadData.year || uploadData.loading">
        <span *ngIf="uploadData.loading" class="spinner-border spinner-border-sm me-2"></span>
        {{ uploadData.loading ? 'Processando...' : 'Enviar' }}
      </button>
    </div>
  </div>
</ng-template>

<!-- Modal para Upload Servidores Censo -->
<ng-template #uploadServidoresCensoModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">Upload Servidores Censo</h4>
    <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <!-- Linha divisória após título principal -->
  <hr class="modal-divider">
  
  <div class="modal-body">
    <h6 class="section-title">Informações do Arquivo</h6>
    <p class="modal-description mb-4">Selecione um arquivo Excel (.xlsx) para importação de servidores para o censo. O arquivo deve conter as colunas: CPF, RG, PIS, Matrícula, Nome Completo, Status, Sexo, Data Nascimento, Estado Civil, Nome da Mãe, Nome do Pai, Nacionalidade, Naturalizado, Estado Naturalidade, Cidade Naturalidade, Escolaridade, PCD, CEP, Tipo Logradouro, Estado, Cidade, Logradouro, Número, Bairro, Complemento, Telefone, Celular, Email, Cargo e Secretaria.</p>

    
    <form #uploadServidoresCensoForm="ngForm" novalidate>
      <div class="form-group mb-4">
        <label for="fileInputServidoresCenso" class="form-label">ARQUIVO EXCEL</label>
        <input 
          type="file" 
          id="fileInputServidoresCenso" 
          class="form-control" 
          accept=".xlsx,.xls"
          (change)="onFileSelected($event)"
          [class.is-invalid]="uploadData.errors.file"
          required>
        <div class="invalid-feedback" *ngIf="uploadData.errors.file">
          {{ uploadData.errors.file }}
        </div>
        <small class="form-text text-muted">Apenas arquivos no formato .xlsx ou .xls são aceitos.</small>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <!-- HR no rodapé ao invés de linha inteira -->
    <hr class="footer-divider">
    <div class="d-flex">
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')" [disabled]="uploadData.loading">
        Voltar
      </button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="processarUploadServidoresCenso(modal)"
        [disabled]="!uploadData.file || uploadData.loading">
        <span *ngIf="uploadData.loading" class="spinner-border spinner-border-sm me-2"></span>
        {{ uploadData.loading ? 'Processando...' : 'Enviar' }}
      </button>
    </div>
  </div>
</ng-template>

<!-- Modal de Cadastro de Anexo FlaxFlow -->
<ng-template #uploadFlaxFlowModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Novo Anexo</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModalFlaxFlow(modal)"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #servForm="ngForm" novalidate>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <button
              type="button"
              class="btn btn-block btn-outline-primary"
              (click)="fileInputFlaxFlow.click()"
            >
              <i class="fa fa-upload"></i> Carregar Documento
            </button>

            <!-- Input file oculto -->
            <input
              #fileInputFlaxFlow
              type="file"
              (change)="selecionaArquivoFlaxFlow($event)"
              class="d-none"
              accept=".xls,.xlsx,.docx,.pdf,.doc"
              multiple
            />
          </div>
        </div>

        <!-- Radios abaixo do botão -->
        <div class="col-md-12 mt-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="opcaoAnexoFlaxFlow"
              id="processarEAnexarFlaxFlow"
              [(ngModel)]="anexoFlaxFlow.opcao"
              value="processarEAnexar"
            />
            <label class="form-check-label" for="processarEAnexarFlaxFlow">
              Processar Documento e Anexar
            </label>
          </div>

          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="opcaoAnexoFlaxFlow"
              id="anexarFlaxFlow"
              [(ngModel)]="anexoFlaxFlow.opcao"
              value="anexar"
            />
            <label class="form-check-label" for="anexarFlaxFlow">Anexar</label>
          </div>

          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="opcaoAnexoFlaxFlow"
              id="processarFlaxFlow"
              [(ngModel)]="anexoFlaxFlow.opcao"
              value="processar"
            />
            <label class="form-check-label" for="processarFlaxFlow">
              Processar Documento
            </label>
          </div>
        </div>
      </div>

      <div *ngIf="statusEnvioFlaxFlow" class="alert alert-info mt-3">
        {{ statusEnvioFlaxFlow }}
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <!-- Botão Voltar -->
        <button
          type="button"
          class="btn btn-outline-primary mt-3"
          (click)="closeModalFlaxFlow(modal)"
        >
          Voltar
        </button>
        <!-- Botão Salvar -->
        <button
          type="button"
          class="btn btn-primary mt-3"
          (click)="cadastrarAnexoFlaxFlow(modal)"
          [disabled]="!anexoFlaxFlow.arquivos || anexoFlaxFlow.arquivos.length === 0"
        >
          Adicionar
        </button>
      </div>
    </form>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>

<!-- Modal para Upload Salário Base -->
<ng-template #uploadSalarioBaseModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">Importação de Salário Base</h4>
    <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <!-- Linha divisória após título principal -->
  <hr class="modal-divider">
  
  <div class="modal-body">
    <h6 class="section-title">Informações da Importação</h6>
    <p class="modal-description mb-4">Selecione um arquivo (CSV ou Excel) para importação dos salários base.</p>
    
    <form #uploadSalarioBaseForm="ngForm" novalidate>
      <div class="form-group mb-3">
        <label for="fileInputSalario" class="form-label">ARQUIVO (CSV ou EXCEL)</label>
        <input 
          type="file" 
          id="fileInputSalario" 
          class="form-control" 
          accept=".csv,.xls,.xlsx"
          (change)="onFileSelected($event)"
          [class.is-invalid]="uploadData.errors.file"
          required>
        <div class="invalid-feedback" *ngIf="uploadData.errors.file">
          {{ uploadData.errors.file }}
        </div>
        <small class="form-text text-muted">Arquivos nos formatos .csv, .xls ou .xlsx são aceitos.</small>
      </div>
      
      <!-- Tabela de colunas esperadas -->
      <div class="card mb-3" style="background-color: #f8f9fa;">
        <div class="card-body py-2">
          <strong class="d-block mb-2"><i class="fa fa-table mr-2"></i>Colunas da Planilha:</strong>
          <table class="table table-sm table-bordered mb-0" style="font-size: 12px;">
            <thead class="thead-light">
              <tr>
                <th>Coluna</th>
                <th>Descrição</th>
                <th>Exemplo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>NOME</code></td>
                <td>Nome do servidor</td>
                <td>João da Silva</td>
              </tr>
              <tr>
                <td><code>CPF</code></td>
                <td>CPF do servidor</td>
                <td>123.456.789-00</td>
              </tr>
              <tr>
                <td><code>MATRICULA</code></td>
                <td>Matrícula do vínculo</td>
                <td>12345</td>

              </tr>
              <tr>
                <td><code>SALARIO</code></td>
                <td>Valor do salário (formato BR)</td>
                <td>2.958,55</td>
              </tr>
              <tr>
                <td><code>STATUS (OPCIONAL)</code></td>
                <td>Situação usada para desempatar vínculos</td>

                <td>Ativo, Aposentado ou Pensionista</td>
              </tr>
            </tbody>
          </table>
          <small class="form-text text-muted mt-2">
            STATUS é opcional. Sem ele, CPF e matrícula devem identificar um único vínculo no município.

          </small>
        </div>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <!-- HR no rodapé ao invés de linha inteira -->
    <hr class="footer-divider">
    <div class="d-flex">
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')" [disabled]="uploadData.loading">
        Voltar
      </button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="processarUploadSalarioBase(modal)"
        [disabled]="!uploadData.file || uploadData.loading">
        <span *ngIf="uploadData.loading" class="spinner-border spinner-border-sm me-2"></span>
        {{ uploadData.loading ? 'Processando...' : 'Enviar' }}
      </button>
    </div>
  </div>
</ng-template>

<!-- Modal para Log de Salário Base -->
<ng-template #logSalarioBaseModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">Resultado do Processamento</h4>
    <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <hr class="modal-divider">
  
  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
    <!-- Loading -->
    <div *ngIf="salarioBaseLoading" class="text-center py-4">
      <i class="fa fa-spinner fa-spin fa-2x text-primary"></i>
      <p class="mt-2 mb-0">Carregando...</p>
    </div>
    
    <!-- Conteúdo do log -->
    <div *ngIf="!salarioBaseLoading && logSalarioBase">
      <!-- Resumo compacto -->
      <div class="resumo-log mb-4" *ngIf="logSalarioBase.resumo">
        <div class="d-flex flex-wrap justify-content-center gap-3">
          <div class="resumo-item text-center" *ngIf="logSalarioBase.resumo.atualizados > 0">
            <span class="resumo-numero text-success">{{ logSalarioBase.resumo.atualizados }}</span>
            <span class="resumo-label">atualizados</span>
          </div>
          <div class="resumo-item text-center" *ngIf="logSalarioBase.resumo.naoEncontrados > 0">
            <span class="resumo-numero text-warning">{{ logSalarioBase.resumo.naoEncontrados }}</span>
            <span class="resumo-label">não encontrados</span>
          </div>
          <div class="resumo-item text-center" *ngIf="logSalarioBase.resumo.erros > 0">
            <span class="resumo-numero text-danger">{{ logSalarioBase.resumo.erros }}</span>
            <span class="resumo-label">erros</span>
          </div>
          <div class="resumo-item text-center" *ngIf="logSalarioBase.resumo.semMovimentoFuncional > 0">
            <span class="resumo-numero text-info">{{ logSalarioBase.resumo.semMovimentoFuncional }}</span>
            <span class="resumo-label">sem mov. funcional</span>
          </div>
          <div class="resumo-item text-center" *ngIf="logSalarioBase.resumo.matriculaInvalida > 0">
            <span class="resumo-numero text-danger">{{ logSalarioBase.resumo.matriculaInvalida }}</span>
            <span class="resumo-label">sem matrícula</span>
          </div>

          <div class="resumo-item text-center" *ngIf="logSalarioBase.resumo.identificacaoAmbigua > 0">
            <span class="resumo-numero text-danger">{{ logSalarioBase.resumo.identificacaoAmbigua }}</span>
            <span class="resumo-label">identificação ambígua</span>
          </div>
          <div class="resumo-item text-center" *ngIf="logSalarioBase.resumo.fallbackCpf > 0">
            <span class="resumo-numero text-info">{{ logSalarioBase.resumo.fallbackCpf }}</span>
            <span class="resumo-label">resolvidos sem matrícula</span>

          </div>
        </div>
        <div class="text-center mt-2 text-muted" style="font-size: 12px;">
          Processado em {{ formatarDataHora(logSalarioBase.dataProcessamento) }}
        </div>
      </div>
      
      <!-- Tabela de servidores atualizados -->
      <div *ngIf="logSalarioBase.detalhes?.atualizados?.length > 0">
        <h6 class="mb-3" style="color: #28a745;">
          <i class="fa fa-check-circle mr-2"></i>Servidores Atualizados
        </h6>
        <div class="table-responsive">
          <table class="table table-sm table-hover mb-0">
            <thead>
              <tr style="background-color: #f8f9fa;">
                <th style="width: 35%;">Servidor</th>
                <th style="width: 15%;">Matrícula</th>
                <th style="width: 18%;">Status</th>
                <th class="text-right" style="width: 16%;">Anterior</th>
                <th class="text-right" style="width: 16%;">Novo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of logSalarioBase.detalhes.atualizados">
                <td>
                  <div class="font-weight-bold" style="font-size: 13px;">{{ item.nome || item.nomeServidor }}</div>
                  <small class="text-muted">{{ formatarCpf(item.cpf) }}</small>
                </td>
                <td>{{ item.matricula || '---' }}</td>
                <td>
                  <span class="badge" 
                    [ngClass]="{
                      'badge-primary': item.statusPlanilha === 'Ativo',
                      'badge-success': item.statusPlanilha === 'Aposentado',
                      'badge-info': item.statusPlanilha === 'Pensionista'
                    }">
                    {{ item.statusPlanilha }}
                  </span>
                </td>
                <td class="text-right text-muted" style="font-size: 13px;">
                  {{ item.valorAnterior | currency:'BRL':'symbol':'1.2-2' }}
                </td>
                <td class="text-right font-weight-bold" style="font-size: 13px; color: #28a745;">
                  {{ item.valorNovo | currency:'BRL':'symbol':'1.2-2' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <!-- Servidores não encontrados -->
      <div *ngIf="logSalarioBase.detalhes?.naoEncontrados?.length > 0" class="mt-4">
        <h6 class="mb-3" style="color: #ffc107;">
          <i class="fa fa-exclamation-triangle mr-2"></i>Não Encontrados
        </h6>
        <div class="table-responsive">
          <table class="table table-sm table-hover mb-0">
            <thead>
              <tr style="background-color: #fff3cd;">
                <th>Servidor</th>
                <th>Matrícula</th>
                <th>Status</th>
                <th>Motivo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of logSalarioBase.detalhes.naoEncontrados">
                <td>
                  <div style="font-size: 13px;">{{ item.nome }}</div>
                  <small class="text-muted">{{ formatarCpf(item.cpf) }}</small>
                </td>
                <td>{{ item.matricula || '---' }}</td>
                <td>{{ item.statusPlanilha }}</td>
                <td>{{ item.mensagem || 'Cadastro não encontrado' }}</td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Identificações ambíguas -->
      <div *ngIf="logSalarioBase.detalhes?.identificacaoAmbigua?.length > 0" class="mt-4">
        <h6 class="mb-3" style="color: #dc3545;">
          <i class="fa fa-exclamation-circle mr-2"></i>Identificação Ambígua
        </h6>
        <div class="table-responsive">
          <table class="table table-sm table-hover mb-0">
            <thead>
              <tr style="background-color: #f8d7da;">
                <th>Servidor</th>
                <th>Matrícula</th>
                <th>Status</th>
                <th>Motivo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of logSalarioBase.detalhes.identificacaoAmbigua">
                <td>
                  <div style="font-size: 13px;">{{ item.nome }}</div>
                  <small class="text-muted">{{ formatarCpf(item.cpf) }}</small>
                </td>
                <td>{{ item.matricula || '---' }}</td>
                <td>{{ item.statusPlanilha }}</td>
                <td class="text-danger">{{ item.mensagem }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Matrículas obrigatórias ausentes -->
      <div *ngIf="logSalarioBase.detalhes?.matriculaInvalida?.length > 0" class="mt-4">
        <h6 class="mb-3" style="color: #dc3545;">
          <i class="fa fa-times-circle mr-2"></i>Matrícula Obrigatória Ausente
        </h6>
        <div class="table-responsive">
          <table class="table table-sm table-hover mb-0">
            <thead>
              <tr style="background-color: #f8d7da;">
                <th>Servidor</th>
                <th>Status</th>
                <th>Motivo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of logSalarioBase.detalhes.matriculaInvalida">
                <td>
                  <div style="font-size: 13px;">{{ item.nome }}</div>
                  <small class="text-muted">{{ formatarCpf(item.cpf) }}</small>
                </td>
                <td>{{ item.statusPlanilha }}</td>
                <td class="text-danger">{{ item.mensagem }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Erros -->
      <div *ngIf="logSalarioBase.detalhes?.erros?.length > 0" class="mt-4">
        <h6 class="mb-3" style="color: #dc3545;">
          <i class="fa fa-times-circle mr-2"></i>Erros
        </h6>
        <div class="table-responsive">
          <table class="table table-sm table-hover mb-0">
            <thead>
              <tr style="background-color: #f8d7da;">
                <th>Servidor</th>
                <th>Erro</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of logSalarioBase.detalhes.erros">
                <td>
                  <div style="font-size: 13px;">{{ item.nome }}</div>
                  <small class="text-muted">{{ formatarCpf(item.cpf) }}</small>
                </td>
                <td class="text-danger">{{ item.erro }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <!-- Mensagem quando tudo está vazio -->
      <div *ngIf="!logSalarioBase.detalhes?.atualizados?.length && 
                  !logSalarioBase.detalhes?.naoEncontrados?.length && 
                  !logSalarioBase.detalhes?.identificacaoAmbigua?.length &&
                  !logSalarioBase.detalhes?.matriculaInvalida?.length &&

                  !logSalarioBase.detalhes?.erros?.length" 
           class="text-center py-4 text-muted">
        <i class="fa fa-info-circle fa-2x mb-2"></i>
        <p class="mb-0">Nenhum registro processado.</p>
      </div>
    </div>
    
    <!-- Erro ao carregar -->
    <div *ngIf="!salarioBaseLoading && !logSalarioBase" class="text-center py-4 text-muted">
      <i class="fa fa-exclamation-circle fa-2x mb-2"></i>
      <p class="mb-0">Não foi possível carregar o log.</p>
    </div>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <hr class="footer-divider">
    <button type="button" class="btn btn-primary" (click)="modal.dismiss('Close')">
      Fechar
    </button>
  </div>
</ng-template>
